import { writable } from "svelte/store";

export const activeTab = writable(-1);
export const allowTrans = writable(false);
export const allowBlend = writable(false);
export const allowFilter = writable(false);
export const isSmall = writable(false);
export const focusBox = writable("body");
export const renderedPost = writable({
  name: "",
  url: "",
});
export const renderVis = writable(false);

const baseFont = { id: 1, slug: "sans", label: "Sans Serif" };

export const postSettings = writable({
  valign: "top",
  fields: 0,
  startCol: "#00ffcc",
  endCol: "#0099ff",
  alpha: 0,
  isGrad: false,
  backdrop: "",
  opacity: 1,
  blending: "normal",
  filter: "nofilter",
});

export const headerStyle = writable({
  typeface: baseFont,
  style: ["bold"],
  fontsize: 12,
  align: "center",
  txtcolor: "#333333",
  hlcolor: "#ffffff",
});

export const bodyStyle = writable({
  typeface: baseFont,
  style: [],
  fontsize: 8,
  align: "left",
  txtcolor: "#333333",
  hlcolor: "#ffffff",
});

export const footerStyle = writable({
  typeface: baseFont,
  style: ["ital"],
  fontsize: 6,
  align: "right",
  txtcolor: "#333333",
  hlcolor: "#ffffff",
});
